import getCharts from '../getCharts'
import { ManageFormData } from '../../constants/api.config'

export default async function ManageDynamicForms(formName="",form="",loginID="",mode="select") {
  try {
    const payload = { formName,form,loginID, mode }
    const res = await getCharts(ManageFormData, payload)
    return res.data
  } catch (error) {
    return error
  }
}
